import React, { FC } from 'react';
import cx from 'classnames';

import useThemeBlock from '@/hooks/useThemeBlock';
import { CardLinkProps } from '@/helpers/CardControls/typings';
import { Link } from '@/helpers/Link/render';
import { Image } from '@/components/molecules/Image/render';

import block from './block.json';
import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
type CardLogoProps = ThemeProps & {
	image: ImageProps;
	link?: CardLinkProps;
};

/**
 * COMPONENT
 */
export const CardLogo: FC<CardLogoProps> & BlockConfigs = ({
	image,
	link: { href = null, opensInNewTab = false, ...linkProps } = {},
	theme = {},
}) => {
	const { variant, blockTheme } = useThemeBlock(block.slug, theme);

	const rootClass = cx(
		'supt-card supt-cardLogo',
		getStyles(blockTheme),
		href && 'supt-withLink'
	);

	return (
		<div
			className={rootClass}
			data-block={block.slug}
			data-variant={variant}
		>
			{href ? (
				<Link
					href={href}
					{...(opensInNewTab && {
						target: '_blank',
						rel: 'noopener noreferrer',
					})}
					{...linkProps}
				>
					<Image {...image} className="supt-cardLogo__image" />
				</Link>
			) : (
				<Image {...image} className="supt-cardLogo__image" />
			)}
		</div>
	);
};

CardLogo.slug = block.slug;
CardLogo.title = block.title;
